export const INPUT_TYPE = {
  INPUT: 'input',
  DATE_RANGE_PICKER: 'date-range-picker',
  SELECT: 'select',
  SELECT_SEARCH: 'select-search',
  HTTP_SELECT: 'http-select',
  DATE_TIME_PICKER: 'datetimepicker',
  TOGGLE: 'toggle',
};
